class CookieConsentPopup extends HTMLElement {
  constructor() {
    super()
    this.btnAcceptAll = this.querySelector('.cookie-consent-popup-main-dialog--accept-all')
    this.btnDeny = this.querySelector('.cookie-consent-popup-main-dialog--deny')
    this.btnMore = this.querySelector('.cookie-consent-popup-main-dialog--more')
    this.mainDialog = this.querySelector('.cookie-consent-popup-main-dialog')
    this.moreDialog = this.querySelector('.cookie-consent-popup-more-dialog')
    this.btnAccept = this.querySelector('.cookie-consent-popup-more-dialog--accept')
    this.btnBack = this.querySelector('.cookie-consent-popup-more-dialog--back')
    this.chbPreferences = this.querySelector('.cookie-consent-popup-more-dialog--preferences')
    this.chbAnalytics = this.querySelector('.cookie-consent-popup-more-dialog--analytics')
    this.chbMarketing = this.querySelector('.cookie-consent-popup-more-dialog--marketing')

    this.state = {
      marketing: false,
      analytics: false,
      preferences: false,
    }
  }

  connectedCallback() {
    this.initConsentApi(this)
    this.btnAcceptAll.addEventListener('click', this.handleAcceptAll.bind(this))
    this.btnDeny.addEventListener('click', this.handleDeny.bind(this))
    this.btnMore.addEventListener('click', this.handleMore.bind(this))
    this.btnAccept.addEventListener('click', this.handleAccept.bind(this))
    this.btnBack.addEventListener('click', this.handleBack.bind(this))
    this.chbMarketing.addEventListener('change', this.handleMarketingChanged.bind(this))
    this.chbPreferences.addEventListener('change', this.handlePreferencesChanged.bind(this))
    this.chbAnalytics.addEventListener('change', this.handleAnalyticsChanged.bind(this))
    this.mappingState.bind(this)
  }

  disconnectedCallback() {
    this.btnAcceptAll.removeEventListener('click', this.handleAcceptAll.bind(this))
    this.btnDeny.removeEventListener('click', this.handleDeny.bind(this))
    this.btnMore.removeEventListener('click', this.handleMore.bind(this))
    this.btnAccept.removeEventListener('click', this.handleAccept.bind(this))
    this.btnBack.removeEventListener('click', this.handleBack.bind(this))
    this.chbMarketing.removeEventListener('change', this.handleMarketingChanged.bind(this))
    this.chbPreferences.removeEventListener('change', this.handlePreferencesChanged.bind(this))
    this.chbAnalytics.removeEventListener('change', this.handleAnalyticsChanged.bind(this))
  }

  handleAcceptAll() {
    this.state.preferences = true
    this.state.analytics = true
    this.state.marketing = true

    this.setTrackingConsent()
  }

  handleDeny() {
    this.state.preferences = false
    this.state.analytics = false
    this.state.marketing = false

    this.setTrackingConsent()
  }

  handleMore() {
    if (this.state.marketing) {
      this.chbMarketing.setAttribute('checked', 'checked')
    } else {
      this.chbMarketing.removeAttribute('checked')
    }
    if (this.state.analytics) {
      this.chbAnalytics.setAttribute('checked', 'checked')
    } else {
      this.chbAnalytics.removeAttribute('checked')
    }
    if (this.state.preferences) {
      this.chbPreferences.setAttribute('checked', 'checked')
    } else {
      this.chbPreferences.removeAttribute('checked')
    }
    this.mainDialog.classList.add('hidden');
    this.moreDialog.classList.remove('hidden');

    this.stopListeningToGTM()
  }

  handleAccept() {
    this.setTrackingConsent()
  }

  handleMarketingChanged() {
    this.state.marketing = this.chbMarketing.checked
  }

  handleAnalyticsChanged() {
    this.state.analytics = this.chbAnalytics.checked
  }

  handlePreferencesChanged() {
    this.state.preferences = this.chbPreferences.checked
  }

  handleBack() {
    this.mainDialog.classList.remove('hidden');
    this.moreDialog.classList.add('hidden');
  }

  setTrackingConsent() {
    window.Shopify.customerPrivacy.setTrackingConsent(
      this.state,
      () => {
        this.classList.add('hidden')
      }
    );

    this.stopListeningToGTM()
  }

  mapConsentToGTM(consent) {
    const analyticsGranted = consent.analytics === 'yes';
    const marketingGranted = consent.marketing === 'yes';
    const saleOfDataGranted = consent.sale_of_data !== 'no'; // 'no' = opt-out, otherwise allow

    window.gtag('consent', 'update', {
      analytics_storage: analyticsGranted ? 'granted' : 'denied',
      ad_storage: marketingGranted && saleOfDataGranted ? 'granted' : 'denied',
      ad_user_data: marketingGranted ? 'granted' : 'denied',
      ad_personalization: marketingGranted ? 'granted' : 'denied',
    });
  }

  stopListeningToGTM() {
    setTimeout(() => {
      window.dataLayer = window['originalDataLayer']
    }, 250)
  }

  initConsentApi(that) {
    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      error => {
        if (error) {
          console.log('cookie-consent-popup: Cannot load the Consent API')
        }

        const currentConsent = window.Shopify.customerPrivacy.currentVisitorConsent();

        that.mappingState(currentConsent);
        const shouldShowPopup = currentConsent.marketing === '' && currentConsent.analytics === '' && currentConsent.preferences === '';

        if (shouldShowPopup) that.classList.remove('hidden')
        else {
          this.mapConsentToGTM(currentConsent)
          this.stopListeningToGTM()
        }
      },
    );
  }

  mappingState(consent) {
    this.state.marketing = consent.marketing === 'yes'
    this.state.analytics = consent.analytics === 'yes'
    this.state.preferences = consent.preferences === 'yes'
  }

  renderMoreDialog() {
  }
}

customElements.define('cookie-consent-popup', CookieConsentPopup)
